import React from "react";
import { useTranslation } from "react-i18next";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-4 mt-4 justify-end items-center  ">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-1 border rounded disabled:opacity-50"
      >
        {t("pagination.prev")}
      </button>

      <span className="px-4 py-1 border rounded bg-black text-white">
        {currentPage}
      </span>

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-1 border rounded disabled:opacity-50"
      >
        {t("pagination.next")}
      </button>
    </div>
  );
};

export default Pagination;

// // src/components/common/Pagination.jsx

// import React from "react";

// const Pagination = ({ currentPage, totalPages, onPageChange }) => {
//     console.log("currentPage === totalPages", currentPage === totalPages);
//     console.log("currentPage", currentPage);
//     console.log("totalPages", totalPages);
//   const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

//   return (
//     <div className="flex gap-2 mt-4 justify-center">
//       <button
//         onClick={() => onPageChange(currentPage - 1)}
//         disabled={currentPage === 1}
//         className="px-3 py-1 border rounded disabled:opacity-50"
//       >
//         Prev
//       </button>
//       {totalPages !== 0 && (pages.map((page) => (
//         <button
//           key={page}
//           onClick={() => onPageChange(page)}
//           className={`px-3 py-1 border rounded ${
//             currentPage === page ? "bg-black text-white" : ""
//           }`}
//         >
//           {page}
//         </button>
//       )))}

//       <button
//         onClick={() => onPageChange(currentPage + 1)}
//         disabled={currentPage === totalPages}
//         className="px-3 py-1 border rounded disabled:opacity-50"
//       >
//         Next
//       </button>
//     </div>
//   );
// };

// export default Pagination;
